import React, { FC, useEffect, useState } from "react";
import { Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { publicService, IRelevanceOrder } from "@/views/public/publicService";
import { useDrodDetailModel } from "../drodDetailModel";
import { getRandomStr } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { editFormVal } = useDrodDetailModel(() => []);
    const [data, setData] = useState<IRelevanceOrder[]>([]);
    const { getTreeNodeName } = useDictModel(() => []);
    //关联单据
    const relevanceOrder = async () => {
        let { retData } = await publicService.relevanceOrder(editFormVal.relevanceOrderId ?? "");
        setData((retData ?? []).map(item => ({
            ...item,
            key: getRandomStr()
        })))
    }
    useEffect(() => {
        relevanceOrder()
    }, [])

    const columns: ColumnsType<IRelevanceOrder> = [
        {
            title: '序号',
            width: 40,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '单据编号',
            width: 160,
            dataIndex: 'code',
        }, {
            title: '单据类型',
            width: 160,
            dataIndex: 'type',
        }, {
            title: '状态',
            width: 160,
            dataIndex: 'status',
            render: text => getTreeNodeName(text)
        }, {
            title: '客户名称',
            width: 160,
            dataIndex: 'name',
        }, {
            //     title: '创建日期',
            //     width: 160,
            //     dataIndex: 'createTime',
            // }, {
            title: '业务员',
            width: 160,
            dataIndex: 'createUser',
        },
    ];


    return (
        <YhBox title="关联业务" style={{ marginBottom: "75px" }}>
            <Table
                columns={columns}
                dataSource={data}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}